import { Box, Skeleton, Stack } from '@mui/material';

const SkeletonCardContent = () => {
  return (
    <Box sx={{ position: 'relative', marginTop: 0 }}>
      <Skeleton variant="rectangular" height={140} />
      <Stack
        direction="column"
        sx={{
          borderRadius: 2,
          boxShadow: 1,
          gap: 1,
          marginLeft: { xs: 2, sm: 5 },
          marginTop: -15,
          position: 'relative',
          p: 1,
        }}
      >
        <Skeleton
          variant="rectangular"
          width={100}
          height={100}
          sx={{ marginLeft: -3, borderRadius: '10px', position: 'absolute', top: 0, left: 0 }}
        />
        <Box sx={{ marginLeft: '110px', marginTop: -2.5 }}>
          <Skeleton variant="text" width="20%" sx={{ marginBottom: 1 }} />
          <Skeleton variant="text" width="40%" sx={{ marginBottom: 1 }} />
          <Skeleton variant="text" width="50%" sx={{ marginBottom: 1 }} />
          <Stack direction="row" spacing={1} sx={{ alignItems: 'center', marginBottom: 1 }}>
            <Skeleton variant="text" width="20%" />
            <Skeleton variant="circular" width={25} height={25} />
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
};

const SkeletonCard = () => {
  return (
    <Box sx={{ marginTop: 2 }}>
      <ListSkeletonItem />
      <Stack direction="column" sx={{ borderRadius: 2, boxShadow: 1, gap: 0.5, marginTop: 4 }}>
        <SkeletonCardContent />
        <SkeletonCardContent />
      </Stack>
    </Box>
  );
};

const ListSkeletonItem = () => {
  return (
    <Box sx={{ position: 'relative', marginBottom: -5 }}>
      <Skeleton variant="text" width="100%" height={100} />
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        sx={{
          position: 'absolute',
          top: '50%',
          left: 0,
          width: '100%',
          transform: 'translateY(-50%)',
          paddingLeft: { xs: 1, sm: 5 },
          boxSizing: 'border-box',
          gap: 2,
          alignItems: 'center',
        }}
      >
        <Skeleton variant="text" sx={{ width: { xs: '80%', sm: 255 } }} height={40} />
        <Skeleton variant="text" sx={{ width: { xs: '60%', sm: 155 }, marginLeft: { sm: 'auto' } }} height={30} />
        <Skeleton variant="text" width={20} height={30} sx={{ marginRight: 2 }} />
      </Stack>
    </Box>
  );
};

const ListSkeleton = () => {
  return (
    <Box>
      {Array.from({ length: 6 }, (_, index) => index + 1).map((id) => (
        <ListSkeletonItem key={`skeleton-item-${id}`} />
      ))}
      <SkeletonCard />
    </Box>
  );
};

export default ListSkeleton;
